import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const issueTypesForProjectsLoad = createJpdExperience(
	new UFOExperience('jpd.issue-types.load-all', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeCreate = createJpdExperience(
	new UFOExperience('jpd.issue-types.create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeDelete = createJpdExperience(
	new UFOExperience('jpd.issue-types.delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeUpdate = createJpdExperience(
	new UFOExperience('jpd.issue-types.update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
